module.exports = __webpack_public_path__ + "img/renderHomeTitle.fb445748.png";